import SaveFormat from "../../../../../common/save/SaveFormat";
import EditorState from "../../../../editor/EditorState";

function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}

function coerceSaveFormat(parsed: unknown): SaveFormat | null {
	if (!isRecord(parsed)) {
		return null;
	}

	if (isRecord(parsed.editor) && Array.isArray(parsed.editor.sheets)) {
		return {
			...parsed,
			editor: {
				...parsed.editor,
				blockPreview: null,
			},
		} as SaveFormat;
	}

	if (Array.isArray(parsed.sheets)) {
		return {
			editor: {
				...(parsed as unknown as EditorState),
				blockPreview: null,
			},
		} as SaveFormat;
	}

	return null;
}

function jsonCandidates(text: string): string[] {
	const candidates: string[] = [];
	const fence = /```(?:json)?\s*([\s\S]*?)```/gi;
	let match: RegExpExecArray | null;

	while ((match = fence.exec(text))) {
		candidates.push(match[1].trim());
	}

	const trimmed = text.trim();
	if (trimmed.startsWith("{") && trimmed.endsWith("}")) {
		candidates.push(trimmed);
	} else {
		const start = text.indexOf("{");
		const end = text.lastIndexOf("}");
		if (start !== -1 && end > start) {
			candidates.push(text.slice(start, end + 1));
		}
	}

	return candidates;
}

export function extractSaveFormatFromText(text: string): SaveFormat | null {
	if (!text) {
		return null;
	}

	for (const candidate of jsonCandidates(text)) {
		try {
			const saveFormat = coerceSaveFormat(JSON.parse(candidate));
			if (saveFormat) {
				return saveFormat;
			}
		} catch {
			continue;
		}
	}

	return null;
}

export function stripSaveFormatJson(text: string): string {
	return text.replace(/```(?:json)?\s*[\s\S]*?```/gi, "").trim();
}
